import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { startParkCall } from "store/call/call.actions";
import useCall from "hooks/redux/useCall";

export default function useParkCall() {

    const { parking } = useCall({});

    const dispatch = useDispatch();

    const park = useCallback(() => {
        dispatch(startParkCall())
    }, [dispatch])

    return {
        park,
        parking
    }

}